import { Date } from "components/Form/components/Date/Date";
import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";

export const DateFormComponent = ({ input, meta, fieldProps, fieldAttr }: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <Date identifier={input?.name} input={input} fieldAttr={fieldAttr} />
        </Input>
    );
};
